import type { UnionToTuple, ValueOf } from "type-fest";
import { z } from "zod";

import type { InferModelType } from "@/common/helpers/models";
import { createModel } from "@/common/helpers/models";

import type { Locale } from "./locale";

const localeToCode = {
  pl: "pl-PL",
} as const satisfies Record<Locale, string>;

const codes = Object.values(localeToCode) as UnionToTuple<ValueOf<typeof localeToCode>>;

export type LocaleCode = InferModelType<typeof localeCodeModel>;

const localeCodeModel = createModel(z.enum(codes));

export const LocaleCode = {
  ...localeCodeModel,
  fromLocale: (locale: Locale) => localeToCode[locale],
};
